import { WaterlilyClient } from '@client/api/waterlily';

export const subscriptionCancellationApi = {
  getSituation(): Promise<SubscriptionCancellationSituationResponse> {
    return WaterlilyClient.get<SubscriptionCancellationSituationResponse>(
      '/subscription-cancellation-situation',
    );
  },

  triggerCancellation(
    data: PutSubscriptionCancellationFeedbackParams,
  ): Promise<PutSubscriptionCancellationFeedbackResponse> {
    return WaterlilyClient.put<PutSubscriptionCancellationFeedbackResponse>(
      '/stripe-subscription-cancellation',
      data,
    );
  },
};
